import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

function MaterialUIPickers(props) {
  // The first commit of Material-UI
  const { classes } = props;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        styles={props.styles}
        classes={{ root: classes.root }}
        margin="none"
        id="date-picker-dialog"
        format="dd-MM-yyyy"
        label="Geburtsdatum auswählen"
        
        value={props.value}
        onChange={props.onChange}
        fullWidth
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />
    </MuiPickersUtilsProvider>
  );
}

const styles = () => ({
  root: {
    // marginLeft: 20,
    // paddingRight: 40,
  }
});

MaterialUIPickers.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  styles: PropTypes.object,
};

MaterialUIPickers.defaultProps = {
  value: '',
  styles: null,
};

export default withStyles(styles)(MaterialUIPickers);



// WEBPACK FOOTER //
// ./src/app/components/picker/date-picker.js